<h4 class="text-center pe-3">{{data.head|translate}}</h4>

<div class="mt-4">
  <ng-container *ngIf="data.text">
    <div class="text-center" [innerHTML]="data.text|translate"></div>
  </ng-container>

  <div class="d-flex mt-4 justify-content-around" *ngIf="typeYes; else typeInfo">

    <button type="button" class="btn btn-outline-secondary px-3" (click)="clickNo()">
      <i class="bi bi-x"></i>
      {{(data.textNo || 'No') | translate}}
    </button>

    <button type="button" class="btn btn-primary px-3" (click)="clickYes()">
      <i class="bi bi-check"></i>
      {{(data.textYes || 'Yes') | translate}}
    </button>
  </div>
  <ng-template #typeInfo>
    <div class="d-flex mt-4 justify-content-center">
      <button type="button" class="btn btn-secondary px-3 min-w-10" (click)="clickNo()">
        {{(data.textNo || 'Ok') | translate}}
      </button>
    </div>
  </ng-template>
</div>
